export const SET_PHONE = 'SET_PHONE';
export const SET_VERIFY_CODE = 'SET_VERIFY_CODE';
export const SET_STEP = 'SET_STEP';
export const SET_ALERT = 'SET_ALERT';
export const SET_LOADING = 'SET_LOADING';


export interface Phone {
  number: string,
  code: string,
  valid: boolean
}

export interface Alert {
  type: 'success' | 'error',
  children: any
}

export type SetPhoneAction = {
  type: typeof SET_PHONE,
  payload: Phone
}

export type SetVerifyCodeAction = {
  type: typeof SET_VERIFY_CODE,
  payload: string
}

export type SetStepAction = {
  type: typeof SET_STEP,
  payload: number
}

export type SetAlertAction = {
  type: typeof SET_ALERT,
  payload: Alert
}

export type SetLoadingAction = {
  type: typeof SET_LOADING,
  payload: boolean
}

export type AuthActions =
  SetLoadingAction |
  SetAlertAction |
  SetPhoneAction |
  SetStepAction |
  SetVerifyCodeAction
